import Vue from "vue";
import Router from "vue-router";
//User Profile
import ProfileList from "@/views/User/Profiles/ProfileList/ProfileList";
import TransactionHistory from "@/views/User/Profiles/ProfileList/transaction-history";

// import UserProfile from "@/views/users/user-profile";
import CreateProfile from "@/views/User/Profiles/CreateProfile/CreateProfile";
import Chat from "@/views/chat/index";
import UserRegister from "@/views/users/index";
import UserLogin from "@/views/users/user-login";
import ResetPassword from "@/views/users/reset-password";
import ChangePassword from "@/views/users/change-password";
import ChangePasswordWithToken from "@/views/users/change-token-password";
import ChangePasswordRedirect from "@/views/users/change-password-redirect";
import Home from "@/views/home/index";
import About from "@/views/about/index";
import Pricing from "@/views/pricing/index";
import PricingDetail from "@/views/pricing-detail/index";
import Contact from "@/views/contact/index";
import Notifications from "@/views/notifications/index";
import CollegeRecruiting from "@/views/college-recruiting/index";
import ClubRecruiting from "@/views/club-recruiting/index";
import PlayerRecruiting from "@/views/player-recruiting/index";
import AthleteProfile from "@/views/User/Profiles/Athlete/ProfileView";

import AthletePictures from "@/views/User/Profiles/Athlete/Pictures/pictures";
import AthleteEventDetail from "@/components/Atheletes/AthleteEvents/EventDetail";
import AthleteEventList from "@/views/athlete-events-list";
import AthleteIndex from "@/views/athletes/index";
import AthleteProfileViews from "@/views/athletes/profile-views";
import AcademicSpecialtiesList from '@/views/academic-specialties-list';
//college profile
import CoachProfile from "@/views/coach/profile/profile-view";
import ClubCoachProfile from "@/views/club-coach/profile/profile-view";
//search profile
// import ProfileSearch from "@/components/CollegeSearch/Index";
import NotFound from "@/views/error/404.vue";
import Forbidden from "@/views/error/403.vue";
import ServerError from "@/views/error/500.vue";
// Coach Register
import CollegeIndex from "@/views/colleges/index";
import CollegeProfile from "@/views/colleges/profile";
import CollegeEventList from "@/views/college-events-list/index";
import CollegeEventDetail from "@/components/College/CollegeEvents/EventDetail";
import RegisterForm from "@/views/registerform/register-form";

import MailToCoach from "@/views/mail-to-coach/index";
//club routes
import ClubIndex from "@/views/clubs/index";
import ClubProfile from "@/views/clubs/profile";
import ClubEventList from "@/components/Club/ClubEvents/EventList";
import ClubEventDetail from "@/components/Club/ClubEvents/EventDetail";
import NewClubForm from "@/views/clubs/form";

//club events routes
import ClubEventIndex from "@/views/club-events/index";
import CollegeEventIndex from "@/views/college-events";

//favourite routes
import FavouriteCollegeIndex from "@/views/favourites/index";
import CoachIndex from "@/views/coach/index";
import CoachDetails from "@/views/coach/details";
import CoachEdit from "@/views/coach/edit";
import CoachNew from "@/views/coach/new";

import ClubCoachIndex from "@/views/club-coach/index";
import ClubCoachDetails from "@/views/club-coach/show";
import ClubCoachEdit from "@/views/club-coach/edit";
import ClubCoachNew from "@/views/club-coach/new";
//news
import NewsIndex from "@/views/news/index";
import NewsDetail from "@/views/news/show";

//roster
import RosterIndex from "@/views/roster/index";
import RosterEdit from "@/views/roster/edit";
import RosterProfile from "@/views/roster/profile";
import RosterNew from "@/views/roster/new";

//highlights
import CollegeTeamHighlightIndex from "@/views/college-team-highlights/index";
import ClubTeamHighlightIndex from "@/views/club-team-highlights/index";
import CollegeTeamHighlightNew from "@/views/college-team-highlights/new";
import CollegeTeamHighlightEdit from "@/views/college-team-highlights/edit";
import ClubTeamHighlightNew from "@/views/club-team-highlights/new";
import ClubTeamHighlightEdit from "@/views/club-team-highlights/edit";
import CollegeTeamHighlightShow from "@/views/college-team-highlights/show";
import ClubTeamHighlightShow from "@/views/club-team-highlights/show";
import ComplainIndex from "@/views/complain/index";
import PrivacyPolicy from "@/views/privacy/index";
import TermsAndConditions from "@/views/terms-conditions/index";

import Paypal from "@/views/paypal/index";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // users auth
    {
      path: "/register",
      name: "UserRegister",
      component: UserRegister,
      beforeEnter: (to, from, next) => {
        if (localStorage["token"]) next({ path: "/" });
        else next();
      }
    },
    {
      path: "/",
      name: "HomePage",
      component: Home,
      beforeEnter: (to, from, next) => {
        if (!localStorage["profile-id"] || window.onlyPlayer()) next();
        else next({ path: `/${localStorage["profile-id"]}/home` });
      }
    },
    {
      path: "/reset-password",
      name: "ResetPassword",
      component: ResetPassword,
      meta: {
        requiresAuth: false
      },
      beforeEnter: (to, from, next) => {
        if (localStorage["token"]) next({ path: "/" });
        else next();
      }
    },

    {
      path: "/change-password",
      name: "ChangePassword",
      component: ChangePassword,
      meta: {
        requiresAuth: true
      },
      beforeEnter: (to, from, next) => {
        if (localStorage["profile-id"])
          next({ path: `/${localStorage["profile-id"]}/change-password` });
        next()
      }
    },
    {
      path: "/:profileId/change-password",
      name: "ChangePasswordWithId",
      component: ChangePassword,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/change-password/:token",
      name: "ChangePasswordWithToken",
      component: ChangePasswordWithToken,
      beforeEnter: (to, from, next) => {
        if (
          window.onlyPlayer() ||
          window.onlyCollegeCoach() ||
          window.onlyClubCoach()
        )
          next({ path: `${localStorage["profile-id"]}/home` });
        next();
      }
    },
    {
      path: "/change-password/invalid/redirect",
      name: "ChangePasswordRedirect",
      component: ChangePasswordRedirect,
      beforeEnter: (to, from, next) => {
        if (
          window.onlyPlayer() ||
          window.onlyCollegeCoach() ||
          window.onlyClubCoach()
        )
          next({ path: `${localStorage["profile-id"]}/home` });
        next();
      }
    },
    {
      path: "/:profileId/chat",
      name: "Chat",
      component: Chat
    },
    {
      path: "/:profileId/chat/:receiverInfo",
      name: "NewChat",
      component: Chat
    },
    {
      path: "/profile",
      name: "ProfileList",
      component: ProfileList,
      props: true,
      meta: {
        requiresAuth: true
      }
      // secure: true
    },
    {
      path: "/:profileId/transaction-history",
      name: "TransactionHistory",
      component: TransactionHistory,
      props: true,
      meta: {
        requiresAuth: true
      }
      // secure: true
    },
    {
      path: "/:profileId/home",
      name: "Home",
      component: Home,
      props: true,
      meta: {
        requiresAuth: false
      }
      // secure: true
    },
    {
      path: "/home",
      name: "HomeWithoutId",
      component: Home,
      props: true,
      meta: {
        requiresAuth: false,
        publicPage: true
      }
      // secure: true
    },
    {
      path: "/login",
      name: "Userlogin",
      component: UserLogin,
      props: true,
      meta: {
        requiresAuth: false
      },
      beforeEnter: (to, from, next) => {
        if (localStorage["profile-id"]) next({ path: `/` });
        else if (localStorage["user-id"]) next({ path: "/profile" });
        else next();
      }
    },
    {
      path: "/about",
      name: "About",
      component: About,
      props: true,
      meta: {
        requiresAuth: false
      }
      // secure: true
    },
    {
      path:"/:profileId/academic-specialties-list",
      name: "AcademicSpecialties",
      component: AcademicSpecialtiesList,
      props: true,
      meta: {
        requiresAuth: false
      }
      // secure: true
    },
    {
      path: "/privacy-policy",
      name: "PrivacyPolicy",
      component: PrivacyPolicy,
      meta: {
        requiresAuth: false
      },
      beforeEnter: (to, from, next) => {
        if (localStorage["profile-id"])
          next({ path: `${localStorage["profile-id"]}/privacy-policy` });
        else next();
      }
    },
    {
      path: "/:profileId/privacy-policy",
      name: "PrivacyPolicyWithId",
      component: PrivacyPolicy,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/terms-and-conditions",
      name: "TermsAndConditions",
      component: TermsAndConditions,
      meta: {
        requiresAuth: false
      },
      beforeEnter: (to, from, next) => {
        if (localStorage["profile-id"])
          next({ path: `${localStorage["profile-id"]}/terms-and-conditions` });
        else next();
      }
    },
    {
      path: "/:profileId/terms-and-conditions",
      name: "TermsAndConditionsWithId",
      component: TermsAndConditions,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: Pricing,
      props: true,
      meta: {
        requiresAuth: false
      },
      beforeEnter: (to, from, next) => {
        if (localStorage["token"]) next({ path: "/404" });
        else next();
      }
      // secure: true
    },
    {
      path: "/pricing-detail",
      name: "PricingDetail",
      component: PricingDetail,
      props: true,
      meta: {
        requiresAuth: false
      },
      beforeEnter: (to, from, next) => {
        if (window.onlyCollegeCoach())
          next({ path: `/404` });
        else next();
      }
      // secure: true
    },
    {
      path: "/:profileId/pricing-detail",
      name: "PricingDetailWithId",
      component: PricingDetail,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
      props: true,
      meta: {
        requiresAuth: false
      }
      // secure: true
    },
    {
      path: "/:profileId/contact",
      name: "ContactWithId",
      component: Contact,
      props: true,
      meta: {
        requiresAuth: false
      }
      // secure: true
    },
    {
      path: "/:profileId/notifications/:userId",
      name: "Notifications",
      component: Notifications,
      props: true,
      meta: {
        requiresAuth: true
      }
      // secure: true
    },
    {
      path: "/:profileId/college-recruiting",
      name: "CollegeRecruitingWithProfileId",
      component: CollegeRecruiting,
      props: true,
      meta: {
        requiresAuth: false
      },
      beforeEnter: (to, from, next) => {
        if (window.onlyCollegeCoach()) next();
        else next({ path: `${localStorage["profile-id"]}/404` });
      }
    },

    {
      path: "/college-recruiting",
      name: "CollegeRecruiting",
      component: CollegeRecruiting,
      props: true,
      meta: {
        requiresAuth: false
      },
      beforeEnter: (to, from, next) => {
        if (window.exceptCollegeCoach()) {
          next({ path: "/404" });
        }
        if (localStorage["profile-id"]) {
          next({ path: `/${localStorage["profile-id"]}/college-recruiting` });
        }
        next();
      }
    },
    // secure: true
    {
      path: "/:profileId/club-recruiting",
      name: "ClubRecruitingWithProfileId",
      component: ClubRecruiting,
      props: true,
      meta: {
        requiresAuth: false
      },
      beforeEnter: (to, from, next) => {
        if (window.onlyClubCoach()) next();
        else next({ path: `${localStorage["profile-id"]}/404` });
      }
      // secure: true
    },
    {
      path: "/club-recruiting",
      name: "ClubRecruiting",
      component: ClubRecruiting,
      props: true,
      meta: {
        requiresAuth: false
      },
      beforeEnter: (to, from, next) => {
        if (window.exceptClubCoach()) {
          next({ path: "/404" });
        }
        if (localStorage["profile-id"]) {
          next({ path: `/${localStorage["profile-id"]}/club-recruiting` });
        }
        next();
      }
    },
    {
      path: "/:profileId/player-recruiting",
      name: "PlayerRecruitingWithProfileId",
      component: PlayerRecruiting,
      props: true,
      meta: {
        requiresAuth: false
      },
      beforeEnter: (to, from, next) => {
        if (window.onlyPlayer()) next();
        else next({ path: `${localStorage["profile-id"]}/404` });
      }
      // secure: true
    },
    {
      path: "/player-recruiting",
      name: "PlayerRecruiting",
      component: PlayerRecruiting,
      props: true,
      meta: {
        requiresAuth: false
      },
      beforeEnter: (to, from, next) => {
        if (window.exceptPlayer()) {
          next({ path: "/404" });
        }
        if (localStorage["profile-id"]) {
          next({ path: `/${localStorage["profile-id"]}/player-recruiting` });
        }
        next();
      }
    },
    {
      path: "/create-profile/:id",
      name: "CreateProfileEdit",
      component: CreateProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
      // secure: true
    },
    {
      path: "/new/create-profile",
      name: "CreateNewProfileNew",
      component: CreateProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
      // secure: true
    },
    {
      path: "/:profileId/athelete/summary",
      name: "AthleteProfile",
      component: AthleteProfile,
      props: true
    },
    {
      path: "/:profileId/athelete/profile_blocking",
      name: "AthleteProfilePb",
      component: AthleteProfile,
      props: true
    },
    {
      path: "/:profileId/athlete/:id/summary",
      name: "AthleteProfileSummaryWithId",
      component: AthleteProfile,
      props: true
    },
    {
      path: "/:profileId/athlete/:id/profile_id",
      name: "AthleteProfilePid",
      component: AthleteProfile,
      props: true
    },
    {
      path: "/:profileId/athelete/basic_information",
      name: "AthleteProfileBid",
      component: AthleteProfile,
      props: true
    },
    {
      path: "/:profileId/athelete/pictures",
      name: "AthletePicturesPic",
      component: AthleteProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/athelete/player_details",
      name: "AthleteProfilePd",
      component: AthleteProfile,
      props: true
    },
    {
      path: "/:profileId/athelete/bio",
      name: "Bio",
      component: AthleteProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/athelete/academic_information",
      name: "AthleteProfileAc",
      component: AthleteProfile,
      props: true
    },
    {
      path: "/:profileId/athelete/videos",
      name: "AthleteProfileVid",
      component: AthleteProfile,
      props: true
    },
    {
      path: "/:profileId/athelete/listing/videos",
      name: "AthleteProfileLvid",
      component: AthleteProfile,
      props: true
    },
    {
      path: "/:profileId/athelete/:id/listing/videos",
      name: "AthleteProfileIDV",
      component: AthleteProfile,
      props: true
    },
    {
      path: "/:profileId/athelete/teams_played",
      name: "AthleteProfileTp",
      component: AthleteProfile,
      props: true
    },
    {
      path: "/:profileId/athelete/events",
      name: "AthleteProfileEvents",
      component: AthleteProfile,
      props: true
    },
    {
      path: "/:profileId/athelete/:id/events",
      name: "AthleteProfileEventId",
      component: AthleteProfile,
      props: true
    },
    {
      path: "/:profileId/athelete/public_view",
      name: "AthleteProfileViewPublic",
      component: AthleteProfile,
      props: true
    },
    {
      path: "/:profileId/athlete/:id/public_view",
      name: "AthleteProfileWithIdPublic",
      component: AthleteProfile,
      props: true
    },
    {
      path: "/:profileId/athlete/:athleteProfileId/event/:eventId",
      name: "AthleteEventDetailWithProfileId",
      component: AthleteEventDetail,
      props: true
    },
    {
      path: "/:profileId/athlete/event/:id",
      name: "AthleteEventDetail",
      component: AthleteEventDetail,
      props: true
    },
    {
      path: "/:profileId/athlete/events",
      name: "AthleteEventList",
      component: AthleteEventList,
      props: true
    },
    {
      path: "/:profileId/college_profile/summary",
      name: "CoachProfile",
      component: CoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/basic_information",
      name: "CoachProfileBasic",
      component: CoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/videos",
      name: "CoachProfileVideos",
      component: CoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/listing/videos",
      name: "CoachProfileVideos",
      component: CoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/:id/listing/videos",
      name: "CoachProfileVideosWithId",
      component: CoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/pictures",
      name: "CoachProfilePictures",
      component: CoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/academic_information",
      name: "CoachProfileVideosAcademic",
      component: CoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/events",
      name: "CoachProfileEvents",
      component: CoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/:id/events",
      name: "CoachProfileVideosEvents",
      component: CoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/:id/summary",
      name: "CollegeProfile",
      component: CoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club_profile/summary",
      name: "ClubCoachProfile",
      component: ClubCoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club_profile/:id/summary",
      name: "ClubCoachProfileId",
      component: ClubCoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club_profile/videos",
      name: "ClubCoachProfileVideos",
      component: ClubCoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club_profile/listing/videos",
      name: "ClubCoachProfileVideos",
      component: ClubCoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club_profile/:id/listing/videos",
      name: "ClubCoachProfileVideos",
      component: ClubCoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club/:id/profile",
      name: "ClubProfile",
      component: ClubCoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },

    // Coach Auth
    {
      path: "/college-coach-register",
      name: "RegisterForm",
      component: RegisterForm,
      beforeEnter: (to, from, next) => {
        if (localStorage["token"]) next({ path: "/" });
        else next();
      }
    },
    {
      path: "/:profileId/colleges",
      name: "CollegeIdIndex",
      component: CollegeIndex,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/events",
      name: "CollegeEventList",
      component: CoachProfile,
      props: true
    },
    {
      path: "/:profileId/college/:id/event/:eventId",
      name: "CollegeEventDetailId",
      component: CollegeEventDetail,
      props: true
    },
    {
      path: "/:profileId/college/event/:eventId",
      name: "CollegeEventDetail",
      component: CollegeEventDetail,
      props: true
    },
    {
      path: "/:profileId/college/events",
      name: "CollegeEventList",
      component: CollegeEventList,
      props: true
    },
    {
      path: "/:profileId/clubs",
      name: "clubIndex",
      component: ClubIndex,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/:profileId/clubs",
      name: "clubIndexProfile",
      component: ClubIndex,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club_profile/events",
      name: "ClubEventList",
      component: ClubCoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club_profile/:id/events",
      name: "ClubEventList",
      component: ClubCoachProfile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club/event/:eventId",
      name: "ClubEventDetail",
      component: ClubEventDetail,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club/:id/event/:eventId",
      name: "ClubEventDetail",
      component: ClubEventDetail,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/paypal",
      name: "asd",
      component: Paypal,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/athletes",
      name: "athleteIndex",
      component: AthleteIndex,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/athletes/profile_views",
      name: "athleteProfileViews",
      component: AthleteProfileViews,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club_events",
      name: "clubEventIndex",
      component: ClubEventIndex,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_events",
      name: "collegeEventIndex",
      component: CollegeEventIndex,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/favourites/college",
      name: "favouritesCollegeIndex",
      component: FavouriteCollegeIndex,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/favourites/club_team",
      name: "favouritesClubIndex",
      component: FavouriteCollegeIndex,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/favourites/club_event",
      name: "favouritesClubEventIndex",
      component: FavouriteCollegeIndex,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/favourites/athlete",
      name: "favouritesClubEventIndex",
      component: FavouriteCollegeIndex,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/favourites/college_event",
      name: "favouritesCollegeEventIndex",
      component: FavouriteCollegeIndex,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/coaching_staffs",
      name: "coachIndex",
      component: CoachProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/coaching_staffs/:id/edit",
      name: "coachEdit",
      component: CoachEdit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/coaching_staffs/new",
      name: "coachNew",
      component: CoachNew,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/coaching_staffs/:id/details",
      name: "coachDetails",
      component: CoachDetails,
      meta: {
        requiresAuth: true
      }
    },
    // News UI
    {
      path: "/:profileId/news",
      name: "NewsIndex",
      component: NewsIndex,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/:profileId/news/:id",
      name: "NewsDetail",
      component: NewsDetail,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/news",
      name: "NewsIndexWithoutId",
      component: NewsIndex,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/news/:id",
      name: "NewsDetailWithoutId",
      component: NewsDetail,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/:profileId/club_profile/roster",
      name: "RosterIndex",
      component: ClubCoachProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club_profile/:id/roster",
      name: "RosterIndex",
      component: ClubCoachProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/roster/:id/edit",
      name: "RosterEdit",
      component: RosterEdit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/roster/:id/profile",
      name: "RosterProfile",
      component: RosterProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/roster/new",
      name: "RosterNew",
      component: RosterNew,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club_profile/coaching_staffs",
      name: "coachIndex",
      component: ClubCoachProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club/coaching_staffs/:id/edit",
      name: "coachEdit",
      component: ClubCoachEdit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club/coaching_staffs/new",
      name: "coachNew",
      component: ClubCoachNew,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club/coaching_staffs/:id/details",
      name: "coachDetails",
      component: ClubCoachDetails,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club_profile/team_highlights",
      name: "clubTeamHighlight",
      component: ClubCoachProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club_profile/:id/team_highlights",
      name: "clubTeamHighlight",
      component: ClubCoachProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club_profile/basic_information",
      name: "ClubProfileInformation",
      component: ClubCoachProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club_profile/pictures",
      name: "ClubProfilePictures",
      component: ClubCoachProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/team_highlights",
      name: "collegeTeamHighlight",
      component: CoachProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/:id/team_highlights",
      name: "collegeTeamHighlight",
      component: CoachProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/team_highlights/new",
      name: "collegeTeamHighlightNew",
      component: CollegeTeamHighlightNew,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/team_highlights/:id/edit",
      name: "collegeTeamHighlightEdit",
      component: CollegeTeamHighlightEdit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/team_highlights/:id/show",
      name: "CollegeTeamHighlightShow",
      component: CollegeTeamHighlightShow,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/college_profile/team_highlights/:id/show/:collegeId",
      name: "CollegeTeamHighlightShow",
      component: CollegeTeamHighlightShow,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club/team_highlights/:id/show",
      name: "ClubTeamHighlightShow",
      component: ClubTeamHighlightShow,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club/:clubId/team_highlights/:id/show",
      name: "ClubTeamHighlightWithClubIdShow",
      component: ClubTeamHighlightShow,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club/team_highlights/new",
      name: "clubTeamHighlightNew",
      component: ClubTeamHighlightNew,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/club/team_highlights/:id/edit",
      name: "clubTeamHighlightEdit",
      component: ClubTeamHighlightEdit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/:profileId/complain",
      name: "complainIndex",
      component: ComplainIndex,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/club-register",
      name: "NewClubForm",
      component: NewClubForm,
      meta: {
        requiresAuth: false
      },
      beforeEnter: (to, from, next) => {
        if (localStorage["token"]) next({ path: "/" });
        else next();
      }
    },
    {
      path: "/:profileId/send-mail-to-coach",
      name: "MailToCoach",
      component: MailToCoach,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/athlete/:athleteId/fromlink",
      name: "AthleteProfileFromLink",
      redirect: to => {
        if (!localStorage["user-permissions"]) return "/";
        if (
          localStorage["user-permissions"] &&
          JSON.parse(localStorage["user-permissions"]) === "player"
        )
          return "/profile";
        return `/${localStorage["profile-id"]}/athlete/${to.params.athleteId}/summary`;
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/club/:clubId/club-event/:eventId/fromlink",
      name: "ClubEventFromLink",
      redirect: to => {
        if (!localStorage["profile-id"]) return "/register";
        return `/${localStorage["profile-id"]}/club/${to.params.clubId}/event/${to.params.eventId}`;
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/college/:collegeId/college-event/:eventId/fromlink",
      name: "CollegeEventFromLink",
      redirect: to => {
        if (!localStorage["profile-id"]) return "/register";
        return `/${localStorage["profile-id"]}/college/${to.params.collegeId}/event/${to.params.eventId}`;
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/403",
      name: "forbidden",
      component: Forbidden
    },
    {
      path: "/500",
      name: "internal-server-error",
      component: ServerError
    },
    {
      path: "*",
      name: "page_not_found",
      component: NotFound
      // meta:{ sidebarclose: true }
    }
  ]
});

router.beforeEach((to, from, next) => {
  const loggedIn =
    localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"));
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next({ name: "page_not_found" });
  }
  next();
});
// router.beforeEach((to, from, next) => {
//   const cookies = document.cookie;
//   if (to.meta != undefined) {
//     let meta_trans = to.meta;
//     if (meta_trans.hasOwnProperty("secure")) {
//       if (cookies == null || cookies.length == 0 || cookies == "") {
//         swal(
//           "Oops, You are not assigned to any role or something went wrong.",
//           "Please try refreshing your browser.",
//           "error"
//         );
//         next({ name: "page_not_found" });
//       } else {
//         next();
//       }
//     } else {
//       next();
//     }
//   }
//   next();
// });
export default router;
